import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(camera => ({
        value: camera.id,
        label: camera.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getVideoWatermarks({ commit }, params) {
      const { data } = await axios.get('v1/services/video/watermarks', { params })

      if (!data.success) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
